import React from 'react';
import c from 'classnames';
import { useStats } from 'react-instantsearch';

import { SearchBar } from '@uncinc/react-searchkit';
import type { SearchBarProps } from '@uncinc/react-searchkit/dist/components/SearchBar';
import type { SearchBarButtonProps } from '@uncinc/react-searchkit/dist/components/SearchBar/Base';

import { Button } from '@uncinc/uncinc-react-kitchen-sink';

import { FormTextField } from '@hvcgroep/design-system';

import './style.scss';

import { useTranslation } from 'react-i18next';

import gtm from '../../../helpers/gtm';

const SearchBarButton = (buttonProps: SearchBarButtonProps) => (
  <Button
    {...buttonProps}
    iconName="search"
    className="search-submit-button icon-after icon-search form-actions"
  />
);

const SearchVacanciesSearchBar: React.FC<SearchBarProps> = (props) => {
  const { className, ...restProps } = props;

  const { t } = useTranslation();

  // nbHits is total number of hits found
  const { nbHits } = useStats();

  const classNames = c('SearchVacancies__SearchBar form-site-search', className);

  return (
    <SearchBar
      {...restProps}
      className={classNames}
      button={SearchBarButton}
      InputComponent={FormTextField}
      placeholder={t('searchkit.vacancies.search_placeholder')}
      onSubmit={(value) => {
        if (!value) return;

        // @ts-expect-error
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        gtm.trackUserEvent('vacancies-filter-search', value);
      }}
      timeout={300}
      // @ts-ignore
      visualValidation={false}
      label={t('searchkit.vacancies.search_label', { count: nbHits })}
      verticalSpacing={false}
    />
  );
};

export default SearchVacanciesSearchBar;
